/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Loader, Main } from "./components";
import { HeroPage, AboutPage, PortfolioPage, ContactPage } from "./pages";
import * as ROUTES from "./constants/routes";
import { PopUpGlobalContext } from "./context/popup";
import GlobalStyle from "./styles/global-style";
import { Circles, Header } from "./containers";
import { NavContext } from "./context/nav";

const App: React.FC = () => {
  const [PopUpOpen, setPopUpOpen] = useState(false);
  const [NavOpen, setNavOpen] = useState(false);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setLoader(false);
    }, 600);
    return () => clearInterval(timer);
  }, []);

  return (
    <Router>
      <PopUpGlobalContext.Provider value={{ PopUpOpen, setPopUpOpen }}>
        <NavContext.Provider value={{ NavOpen, setNavOpen }}>
          <GlobalStyle open={PopUpOpen} navOpen={NavOpen} />
          <Main>
            <Circles />
            {loader ? (
              <Loader fadeOut={loader} />
            ) : (
              <>
                <Header />
                <Route exact path={ROUTES.HOME}>
                  <HeroPage />
                </Route>
                <Route exact path={ROUTES.ABOUT}>
                  <AboutPage />
                </Route>
                <Route exact path={ROUTES.PORTFOLIO}>
                  <PortfolioPage />
                </Route>
                <Route exact path={ROUTES.CONTACT}>
                  <ContactPage />
                </Route>
              </>
            )}
          </Main>
        </NavContext.Provider>
      </PopUpGlobalContext.Provider>
    </Router>
  );
};

export default App;
